module.exports = __webpack_public_path__ + "img/RotateR.7af1d5b7.png";